if (!customElements.get('mg-restock-request')) {
  class MotusRestockRequest extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.product = this.closest('mg-product');
      this.colour = this.querySelector('[data-mg-restock-colour]');
      if (!this.product || !this.colour) return;
      this.data = JSON.parse(this.product.querySelector('[data-mg-data]').textContent);
      const signal = this.abort.signal;
      this.product.addEventListener('change', event => {
        if (event.target.matches('.mg-pdp__option input, [data-mg-variant]')) this.sync();
      }, {signal});
      this.colour.addEventListener('change', () => {
        const option = this.colour.selectedOptions[0];
        const variant = this.data.variants.find(item => String(item.id) === option.dataset.variantId);
        if (!variant) return;
        const fields = [...this.product.querySelectorAll('.mg-pdp__option')];
        fields.forEach((field, index) => {
          const input = [...field.querySelectorAll('input')].find(item => item.value === variant.options[index]);
          if (input) input.checked = true;
        });
        this.product.querySelector('[data-mg-variant]').value = String(variant.id);
        const input = fields[0]?.querySelector('input:checked');
        if (input) input.dispatchEvent(new Event('change', {bubbles:true}));
        this.apply(variant);
      }, {signal});
      this.querySelector('form').addEventListener('submit', () => this.sync(), {signal});
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
    sync() {
      const fields = [...this.product.querySelectorAll('.mg-pdp__option')];
      const options = fields.map(field => field.querySelector('input:checked')?.value);
      const selectedId = this.product.querySelector('[data-mg-variant]').value;
      const variant = fields.length
        ? this.data.variants.find(item => item.options.every((value, index) => value === options[index]))
        : this.data.variants.find(item => String(item.id) === selectedId);
      this.apply(variant);
    }
    apply(variant) {
      this.hidden = !variant || variant.available;
      const add = this.product.querySelector('[data-mg-add]');
      add.hidden = Boolean(variant && !variant.available);
      if (!variant) return;
      this.colour.value = variant.options.join(' / ');
      this.querySelector('[data-mg-restock-id]').name = 'contact[Variant ID]';
      this.querySelector('[data-mg-restock-id]').value = String(variant.id);
      const url = new URL(location.href);
      url.search = '';
      url.hash = '';
      url.searchParams.set('variant', variant.id);
      this.querySelector('[data-mg-restock-url]').value = url.href;
    }
  }
  customElements.define('mg-restock-request', MotusRestockRequest);
}
